package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.storage.provideTokenStorage
import br.com.texeratx.boardgametimeapp.data.repository.LoginRepository
import br.com.texeratx.boardgametimeapp.domain.usecases.login.ForgotPasswordUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.login.LoginUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.login.ResetPasswordUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.login.SignupUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.forgot_password.ForgotPasswordViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.login.LoginViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.ChangePasswordViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.reset_password.ResetPasswordViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.signup.SignupViewModel
import org.koin.dsl.module

val loginModule = module {

    // TokenStorage
    single { provideTokenStorage() }

    // Repository
    single { LoginRepository(get()) }

    // UseCases
    factory { LoginUseCase(get(), get()) }
    factory { SignupUseCase(get(), get()) }
    factory { ForgotPasswordUseCase(get()) }
    factory { ResetPasswordUseCase(get()) }

    // ViewModels
    factory { LoginViewModel(get(), get()) }
    factory { SignupViewModel(get(), get()) }
    factory { ForgotPasswordViewModel(get(), get()) }
    factory { ResetPasswordViewModel(get(), get()) }
    factory { ChangePasswordViewModel(get(), get(), get()) }
}
